import TableDialog from './src'

TableDialog.install = Vue => {
  Vue.component(TableDialog.name, TableDialog)
}

export default TableDialog
